import { Staff } from "@/api/company-api";
import { User } from "@/api/user-api";

export default class ProjectMember {
  projectMemberId: number = 0;
  user: User = new User();
  staff: Staff = {
    staffId: 0,
    officeId: 0,
    name: "unknown",
    tel: "",
    mail: "",
    workTypeIds: [],
    isHiddenInfo: 0,
    scheduleNotification: false,
    canModifyAssignedTasks: false,
    canViewAllUninvitedProjects: false
  };

  public constructor(params?: ProjectMember) {
    if (!params) return;
    this.projectMemberId = params.projectMemberId;
    this.user = params.user;
    this.staff = params.staff;
  }
}
